import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useBarometerCarInPrepare() {
  const { startListen } = useWebSocketStore()
  const { updateBarometerCarData } = useUpdateCar()

  const carInPrepare = () => {
    startListen({
      eventName: 'premium.CAR_IN_PREPARE',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        updateBarometerCarData('unknown', event.context.carId, (data) => {
          return {
            ...data,
            stage: 'IN_PREPARATION',
          }
        })
      },
    })
  }

  return { carInPrepare }
}
